// extracted by mini-css-extract-plugin
export var bodyRow = "_du-d";
export var cardColumns = "_du-e";
export var ellipsesOverflow = "_du-2";
export var flatBottomCorners = "_du-3";
export var flatTopCorners = "_du-4";
export var headerActionsDropdown = "_du-f";
export var headerBottomRow = "_du-c";
export var headerTopRow = "_du-b";
export var orderDetailsWrapper = "_du-0";
export var orderInfoContainer = "_du-1";
export var productDetails = "_du-9";
export var productImage = "_du-5";
export var responsiveTable = "_du-8";
export var shipmentContainer = "_du-a";
export var tableBottomLeft = "_du-6";
export var tableBottomRight = "_du-7";
export var trackingLink = "_du-g";